// @flow
import React from 'react';
import Wrapper from './FormFieldWrapper';
import Text from '../shared/Typography';

type InputProps = {
  selected: string,
  options: Array,
  name: string,
  label: string,
  onChange: (number: string) => void,
  className: string,
  required: boolean,
  type: string,
  error: string,
  helpText: string,
  ref: string,
  children: any, /* meant for search suggestions list */
  focusOnMount: boolean,
  province: boolean,
  edit?: boolean,
  helpTextBelow: boolean, /* default: help text hovers to right until bmobile breakpoint.
  adding this makes it below form always */
  disabled?: boolean
}

const provinces = ['',
  'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
  'Newfoundland and Labrador', 'Northwest Territories',
  'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Saskatchewan', 'Yukon', 'Québec'];

const newProvinces = [];

const mapProvinces = () => {
  provinces.map((province) => {
    return newProvinces.push({
      name: province,
      label: province
    });
  });
  return newProvinces;
};

mapProvinces();

class DropdownInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHelpText: false,
      selected: false
    };
  }
  props: InputProps
  render() {
    const { onChange, selected, options, className,
      label, name, children, focusOnMount, error, province, edit } = this.props;
    return (
      <Wrapper
        helpText={children}
        showHelpText={this.state.showHelpText}
        className='dropdown__container'
      >
        <label className={`control is-dropdown ${className}`} htmlFor={name}>
          <Text
            paragraph
            className={
            selected || edit ?
            'label-text dropdown__label--small'
            : 'label-text dropdown__label'}
          >
            {label}
          </Text>
          <select
            disabled={this.props.disabled}
            onChange={(e) => { onChange(e); this.setState({ selected: true }); }}
            value={selected}
            className={`input ${error ? 'has-error' : ''}`}
            id={name}
            name={name}
            ref={focusOnMount ?
              (input) => input && input.focus() :
              'none'}
            onFocus={(e) => {
              this.setState({ showHelpText: true });
              e.target.value = e.target.value;
            }}
            onBlur={() => this.setState({ showHelpText: false })}
            tabIndex={focusOnMount ? 1 : 0}
          >

            {province ?
              newProvinces.map((option, i) => (
                <option value={option.value} key={`${i}-${option.value}`}>{option.label}</option>
              ))
              : options.map((option, i) => (
                <option value={option.value} key={`${i}-${option.value}`}>{option.label}</option>
                ))}

          </select>
          {children}
          {error ? <p className='error-text'>{error}</p> : ''}
        </label>
      </Wrapper>
    );
  }
}

export default DropdownInput;



// WEBPACK FOOTER //
// ./src/components/shared/DropdownInput.js